import React, { Component, PureComponent } from "react";
// import axios from 'axios'
import { PageRoot, PageTitle, GridContainer ,PageContainer} from "./PaymentPoints.style";
// import { CardInfo } from "./CardInfo/CardInfo";
import { MonsterPoint } from "./MonsterPoint/MonsterPoint";
import { OrderHistory } from "./OrderHistory/OrderHistory";
import { Payment } from "./Payment/Payment";
// import singlepay from "../../Payment/Charge/singlepay";
import i18n from '../../i18n';

import { connect } from 'react-redux'

export class PaymentPointsComponent extends PureComponent  {
  constructor() {
    super();

    var today = new Date(),
      date =
        today.getFullYear() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getDate();

    this.state = {
      date: date,
    };
  }
  
  render() {
    const { date } = this.state;
    return (
      <PageRoot>
        <PageContainer>
          <PageTitle>{i18n.t("paymentpoints.title")}</PageTitle>
          <GridContainer>
            {/* <CardInfo /> */}
            <Payment date={date} {...this.props} />
            <MonsterPoint {...this.props} />
            <OrderHistory {...this.props} />
          </GridContainer>
        </PageContainer>
      </PageRoot>
    );
  }
}

const mapStateToProps = state => ({
  paymentMode: state.paymentModeStore.paymentMode,
  pointTicket: state.pointTicketStore.pointTicket,
  payments: state.paymentsStore.payments,
})

export const PaymentPoints = connect(mapStateToProps, null)(PaymentPointsComponent)